import { Pipe, PipeTransform } from '@angular/core';

export const bytesFormatter = {
    /**
     * bytes: the number of bytes to transform.
     * precision: the number of digits to appear after the decimal point.
     */
    transform(bytes: number, precision = 1): string {
        if (isNaN(bytes) || !isFinite(bytes) || bytes < 0 || bytes === null) {
            return '';
        }
        const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
        const value = Math.floor(Math.log(bytes) / Math.log(1024));
        const fixedBytes = (bytes / Math.pow(1024, value)).toFixed(precision);
        return `${fixedBytes} ${units[value]}`;
    }
};

/**
 * Formats bytes number to bytes plus unit string
 */
@Pipe({ name: 'apBytes' })
export class ApBytesPipe implements PipeTransform {
    /**
     * bytes: the number of bytes to transform.
     * precision: the number of digits to appear after the decimal point.
     */
    transform(bytes: number, precision = 1): string {
        return bytesFormatter.transform(bytes, precision);
    }
}
